import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ModeloRdService {

  constructor(
    private http: HttpClient,
    private account: AccountService
  ) { }

  urlBase = `${SCAMP_API.accountApiV1}/rd-modelos`;

  add(data: any) {
    return this.http.post(`${SCAMP_API.accountApiV1}/rd-modelos`, data,
      { headers: this.account.composeHeaders() });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${SCAMP_API.accountApiV1}/rd-modelos/${id}`,
      { headers: this.account.composeHeaders() });
  }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/rd-modelos`,
      { headers: this.account.composeHeaders() });
  }

  getAllPromise(): Promise<Response> {

    return fetch(this.urlBase, {
      method: 'GET', 
      headers: this.account.getHearderAuthorization()
    })
  }


  deleteById(id: number) {
    return this.http.delete(`${SCAMP_API.accountApiV1}/rd-modelos/${id}`,
      { headers: this.account.composeHeaders() });
  }

  isUniqueNome(nome: string, id: number): Observable<boolean> {
    return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/rd-modelos/is-unique-nome`, { nome, id },
      { headers: this.account.composeHeaders() });
  }

  isUniquePrefixo(prefixo: string, id: number): Observable<boolean> {
    return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/rd-modelos/is-unique-prefixo`, { prefixo, id },
      { headers: this.account.composeHeaders() });
  }


}


